<template>
  <div>
    <v-row>
      <v-col v-if="canManagePms" cols="3" class="py-0">
        <v-select
          v-model="item.settings.subscription_plan"
          :items="planOptions"
          :label="$t('plan')"
          :rules="required ? [v => !!v || $t('required')] : []"
          outlined
          rounded
          dense
        ></v-select>
      </v-col>
      <v-col v-if="canManagePms" cols="3" class="py-0">
        <v-select
          v-model="item.pms"
          :items="pmsOptions"
          :label="$t('pms')"
          :rules="required ? [v => !!v || $t('required')] : []"
          outlined
          rounded
          dense
          @change="$emit('pms-change', $event)"
        ></v-select>
      </v-col>
    </v-row>

    <!-- PMS: ULYSES -->
    <template v-if="item.pms === 'ulyses'">
      <v-row>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.ulyses_api_environment"
            :label="$t('ulyses_api_environment')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.ulyses_api_username"
            :label="$t('ulyses_api_username')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.ulyses_api_password"
            :label="$t('ulyses_api_password')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
            type="password"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.ulyses_private_api_environment"
            :label="$t('ulyses_private_api_environment')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.ulyses_authorization_key"
            :label="$t('ulyses_authorization_key')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.pms_chain_id"
            :label="$t('pms_chain_id')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.pms_hotel_id"
            :label="$t('pms_hotel_id')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
          ></v-text-field>
        </v-col>
      </v-row>
    </template>

    <!-- PMS: GUESTPRO -->
    <v-row v-if="item.pms === 'guestpro'">
      <v-col cols="3" class="py-0">
        <v-text-field
          v-model="item.settings.guestpro_hotel_id"
          :label="$t('guestpro_hotel_id')"
          :rules="required ? [v => !!v || $t('required')] : []"
          outlined
          rounded
          dense
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- PMS: FNSROOMS -->
    <template v-if="item.pms === 'fnsrooms'">
      <v-row>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.fns_rooms_user"
            :label="$t('fns_rooms_user')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.fns_rooms_password"
            :label="$t('fns_rooms_password')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
            type="password"
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.fns_rooms_pms_id"
            :label="$t('fns_rooms_pms_id')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.fns_rooms_alojamiento_id"
            :label="$t('fns_rooms_alojamiento_id')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.fns_rooms_central_id"
            :label="$t('fns_rooms_central_id')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="3" class="py-0">
          <v-text-field
            v-model="item.settings.fns_rooms_moneda_id"
            :label="$t('fns_rooms_moneda_id')"
            :rules="required ? [v => !!v || $t('required')] : []"
            outlined
            rounded
            dense
          ></v-text-field>
        </v-col>
      </v-row>
    </template>

    <!-- Reset revenue (only in edit mode when PMS has changed) -->
    <v-row v-if="isEditing && pmsChanged" class="mt-1">
      <v-col cols="12" class="pt-0 pb-5">
        <div class="d-flex align-center">
          <v-switch
            :input-value="resetRevenueData"
            @change="$emit('update:resetRevenueData', $event || false)"
            color="warning"
            dense
            hide-details
            class="mt-0 pt-0 mr-3 flex-shrink-0"
          ></v-switch>
          <div>
            <div class="body-2 font-weight-medium">
              {{ $t("reset_revenue_data_checkbox") }}
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "a-hotel-pms-config",
  props: {
    item: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    originalPms: {
      type: String,
      default: null
    },
    resetRevenueData: {
      type: Boolean,
      default: false
    },
    canManagePms: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    pmsChanged() {
      return (
        this.originalPms !== null &&
        this.item.pms !== undefined &&
        this.item.pms !== this.originalPms
      );
    },
    planOptions() {
      return [
        { text: this.$t("plan_discover"), value: "discover" },
        { text: this.$t("plan_expand"), value: "expand" },
        { text: this.$t("plan_optimise"), value: "optimise" }
      ];
    },
    pmsOptions() {
      return [
        { text: this.$t("pms_manual"), value: "manual" },
        { text: this.$t("pms_ulyses"), value: "ulyses" },
        { text: this.$t("pms_guestpro"), value: "guestpro" },
        { text: this.$t("pms_fnsrooms"), value: "fnsrooms" },
        { text: this.$t("pms_sihot"), value: "sihot" },
        { text: this.$t("pms_prestige"), value: "prestige" }
      ];
    }
  }
};
</script>
